// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "f8d4254095deac99c95a137384ccb2635eb63deb/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};